import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#05050A]">
        <Loader2 className="w-8 h-8 text-[#F43F5E] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/entrar" state={{ from: location.pathname }} replace />;
  return children;
}
